var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCultural(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.06,2.81V28.79s14.33-6.32,21.15,4.21V6.47S20.76-2.81,5.06,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.98,8.21c3.07-.65,8.74-1.37,13.08,.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.47,14.44c3.16-.62,8.48-1.16,12.6,.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.47,20.05c3.16-.62,8.48-1.16,12.6,.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.26,8.21c-3.07-.65-8.74-1.37-13.08,.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.78,14.44c-3.16-.62-8.48-1.16-12.6,.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.78,20.05c-3.16-.62-8.48-1.16-12.6,.93"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.37,2.81V28.79s-14.33-6.32-21.15,4.21V6.47s5.46-9.28,21.15-3.67Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.06 5.71 1 5.71 1 33 25.84 33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.94 5.71 51 5.71 51 33 26.17 33"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCultural);
export default __webpack_public_path__ + "static/media/icon_cultural.d384184e5e5dd666dc35a2456bddb570.svg";
export { ForwardRef as ReactComponent };